import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { CustomerForm, CustomerFormType } from './CustomerForm'
import { getCustomerById, updateCustomer } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Customers',
    path: '/customers'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditCustomer = () => {
  const { customerId } = useParams()
  const { createToast } = useAppContext()
  const [customer, setCustomer] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const row = await getCustomerById(customerId)
        setCustomer({ ...row, salesUser: { id: row.salesUserId, name: row.salesUser } })
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateCustomer(customerId, {
        company: form.company,
        prefix: form.prefix,
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        phone: form.phone,
        salesUserId: form.salesUser.id,
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip
      })
      if (row) {
        setCustomer(row)
        createToast('success', 'Customer updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Customer</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <CustomerForm
              type={CustomerFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={customer}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
